import React, { useEffect } from 'react';
import Header from '../../../shared/Header/Header';
import Footer from '../../../shared/Footer/Footer';
import SectionHeader from '../../../layouts/showcaseLayouts/Section/SectionHeader/SectionHeader';
import SectionBody from '../../../layouts/showcaseLayouts/Section/SectionBody/SectionBody';
import SectionBodyGrid from '../../../layouts/showcaseLayouts/Section/SectionBody/SectionBodyGrid/SectionBodyGrid';
import './bestSilkPage.scss';

const FEATURES = [
    'Гипоаллергенный',
    'Гигроскопичный',
    'Воздухопроницаемый',
    'Антибактериальный',
    'Долговечный',
    'Не электризуется',
    'Благоприятно влияет на кожу',
    'Тактильный.',
];

const BestSilkPage: React.FC = () => {
    useEffect(() => {
        const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const targets = Array.from(document.querySelectorAll<HTMLElement>('.reveal'));

        if (prefersReduced) {
            targets.forEach((el) => el.classList.add('is-visible'));
            return;
        }

        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('is-visible');
                        io.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.2 },
        );

        targets.forEach((el) => io.observe(el));
        return () => io.disconnect();
    }, []);

    return (
        <div className="bestSilkPage">
            <Header />
            <div className="bestSilkPage_headerWrapper">
                <SectionHeader title="О самом лучшем в мире шелке" />
            </div>
            <SectionBody>
                <SectionBodyGrid>
                    <>
                        <section className="bestSilkPage__features reveal" aria-labelledby="silk-features-title">
                            <h2 id="silk-features-title" className="bestSilkPage__featuresTitle" aria-label="Свойства шелка">
                                ШЕЛК
                            </h2>
                            <ul className="bestSilkPage__featuresGrid">
                                {FEATURES.map((item) => (
                                    <li key={item} className="featureCard" aria-label={item}>
                                        <span className="featureCard__check" aria-hidden="true">
                                            ✓
                                        </span>
                                        <span className="featureCard__text">{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </section>
                        <div className="bestSilkPage__twoCol">
                            <aside className="bestSilkPage__media reveal" aria-hidden="true">
                                <div className="bestSilkPage__mediaBg">
                                    <img className="bestSilkPage__bg" src="/best-silk/01.jpg" alt="" decoding="async" loading="eager" />
                                </div>
                                <img className="bestSilkPage__img" src="/best-silk/02.jpg" alt="Иллюстрация 2" decoding="async" loading="lazy" />
                            </aside>

                            <article className="bestSilkPage__copy reveal">
                                <p>
                                    Вся продукция торгового дома С. Габай изготовлена из 100% натурального шелка, рожденного в самом сердце среды обитания
                                    шелкопрядов – городе Сучжоу (Китай).
                                </p>

                                <p>
                                    На протяжении пяти тысячелетий шелковые постельные принадлежности и одежда были символом исключительной роскоши и считались
                                    привилегией членов императорской семьи. Согласно легенде, первооткрывательницей шелка стала Лэй Цзу – супруга императора Хуан-Ди.
                                    Во время чайной церемонии в тенистом саду кокон тутового шелкопряда упал в чашу императрицы. Горячая вода размягчила его, явив
                                    миру сверкающую белую нить. Пораженная красотой и прочностью нити, Лэй Цзу велела собрать коконы и соткать из нитей одеяние для
                                    императора, которое получилось просто великолепным. Императрица получила новое имя «Си Линчи» - «владычица шелкового червя» и
                                    вошла в историю как «Богиня шелка», а шелк стал символом роскоши и красоты, со временем получая все большее распространение.
                                </p>

                                <p>
                                    В природе выделяют три основных вида шелка: Тусса, Малбери и Голд, которые различаются длиной и толщиной нити, структурой,
                                    прочностью, связностью и натяжением. Качество шелковой нити по всем показателям возрастает от Тусса к Голд. Шелкопряды, из
                                    коконов которых получают шелк Тусса, живут в дикой природе, питаясь преимущественно листьями дуба. Шелкопряды, чьи нити
                                    преображаются в нежнейший шелк Малбери и солнечный золотой шелк, питаются исключительно листьями тутового дерева одного сорта.
                                    Именно эта избирательность позволяет получить однородные волокна, достойные изделий премиум-класса.
                                </p>

                                <p>
                                    Первоначальный цвет шелка определяется естественными пигментами, которые шелкопряды выделяют, когда едят листья шелковицы, но под
                                    воздействием определенного гена Y шелкопряды могут извлекать желтые соединения из листьев (каротиноиды, флавоноиды и лютеин), и
                                    тогда получается золотой шелк.
                                </p>

                                <p>
                                    Каждые одеяло и подушка "С.Габай" – это полностью ручной труд. Мы бережно отбираем идеально целые, неповрежденные коконы,
                                    содержащие две куколки, чтобы получить максимально длинную и безупречно качественную нить, благодаря чему изделия надолго
                                    сохраняют свои уникальные свойства и красоту.
                                </p>

                                <p>
                                    Уникальность шелка заключается не только в привлекательном внешнем виде, но и в пользе для здоровья. Шелк - гипоаллергенный
                                    материал, подходящий людям даже с очень чувствительной кожей. Содержащиеся в его составе белки и аминокислоты способствуют
                                    замедлению процессов старения, благоприятно воздействуют на кожу и волосы. Шелк отличается высокой степенью гигроскопичности и
                                    гигиеничности. Его с давних времен использовали в медицине, а белок серицин в составе шелкового наполнителя предотвращает
                                    развитие клещей, грибка и бактерий. Шелк является природным терморегулятором. Изделия из шелка быстро приспосабливаются к
                                    температуре окружающей среды, поддерживая идеальный микроклимат в любое время года: летом под шелковым одеялом не жарко, а зимой
                                    – тепло.
                                </p>

                                <p>С одеялом и подушками С.Габай вы словно погружаетесь в сон на лоне природы, ощущая ее благодатную силу и легкость.</p>
                            </article>
                        </div>
                    </>
                </SectionBodyGrid>
            </SectionBody>
            <Footer />
        </div>
    );
};

export default BestSilkPage;
